<div class="basic-info-component fx-layout-column">
  @if (isProposed) {
    <div class="mat-hint">
      @if (proposingOrganisationId) {
        <app-key-value key="{{ 'ProposingOrganisationId' | transloco }}" value="{{ proposingOrganisationId }}" />
      }
      @if (proposedInFlowchartElementType) {
        <app-key-value
          key="{{ 'ProposedInFlowchartElementType' | transloco }}"
          value="{{ proposedInFlowchartElementType | wrapFn: getKeyFromType : FlowchartElementType }}" />
      }
      @if (proposedInGuidelineChapterType) {
        <app-key-value
          key="{{ 'ProposedInGuidelineChapterType' | transloco }}"
          value="{{ proposedInGuidelineChapterType | wrapFn: getKeyFromType : GuidelineChapterType }}" />
      }
    </div>
  } @else {
    <div class="mat-hint">
      <app-key-value key="{{ 'Version' | transloco }}" value="{{ version ? version : '-' }}" />
    </div>
  }

  @if (code) {
    <div class="mat-hint">
      <app-key-value key="{{ 'Treetopcode' | transloco }}" value="{{ code ? code : '-' }}" />
    </div>
  }

  <div class="mat-hint">
    @if (author?.trim()) {
      <span>
        <app-key-value key="{{ 'Author' | transloco }}" value="{{ author ? author : '-' }}" />
      </span>
    }
    @if (createdAt) {
      <app-key-value key="{{ 'CreatedAt' | transloco }}" value="{{ createdAt | utcToLocal }}" />
    }
    @if (editor?.trim()) {
      <span>
        <app-key-value key="{{ 'Editor' | transloco }}" value="{{ editor ? editor : '-' }}" />
      </span>
    }
    @if (updatedAt) {
      <app-key-value key="{{ 'UpdatedAt' | transloco }}" value="{{ updatedAt | utcToLocal }}" />
    }
  </div>

  @if (!isProposed) {
    <div class="mat-hint">
      @if (reviewer?.trim()) {
        <span>
          <app-key-value key="{{ 'Reviewer' | transloco }}" value="{{ reviewer ? reviewer : '-' }}" />
        </span>
      }
      @if (approvedDate) {
        <app-key-value key="{{ 'ApprovedDate' | transloco }}" value="{{ approvedDate | utcToLocal }}" />
      }
      @if (publisher?.trim()) {
        <span>
          <app-key-value key="{{ 'Publisher' | transloco }}" value="{{ publisher ? publisher : '-' }}" />
        </span>
      }
      <app-key-value key="{{ 'PublishDate' | transloco }}" value="{{ publishDate | utcToLocal }}" />
    </div>
  }

  @if (actionType) {
    <div class="mat-hint">
      <app-key-value
        key="{{ 'ActionType' | transloco }}"
        value="{{ actionType | wrapFn: getKeyFromType : ActionType | transloco }}" />
      @if (treetopCode) {
        <app-key-value key="{{ 'Treetopcode' | transloco }}" value="{{ treetopCode }}" />
      }
    </div>
  }

  @for (coding of codings; track coding) {
    @if (codingSystemsMap()?.get(coding.systemId); as codingSystem) {
      <app-key-value key="{{ codingSystem.title }}" tooltip="{{ coding.versionId }}" value="{{ coding.code }}" />
    }
  }
</div>
